import { useState } from "react"
import SuggestList from "./SuggestList"

/*
    > nu e chiar smart dar nu stiam ce alt nume sa pun
    > wrapper pt un camp de formular care ofera sugestii de completare
    in functie de ce se afla in lista 'values'
*/
function SmartTextField({ name, placeholder, defaultValue, values, changeHandler, type }) {
    return <>
        <input 
            type={type ? type : `text`} 
            name={name}
            id={name}
            placeholder={placeholder}
            list={`${name}-suggestions`}
            defaultValue={(defaultValue) ? defaultValue : ``}
            onChange={(e) => {
                if(changeHandler)
                    changeHandler(e.target.value)
            }}
            required
        />

        {
            values && values.length > 0
                ? <SuggestList name={`${name}-suggestions`} values={values} />
                : null
        }
    </>
}

export default SmartTextField